import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1667 4.24984H12.0417V2.83317C12.0417 2.05188 11.4064 1.4165 10.6251 1.4165H6.37508C5.59379 1.4165 4.95842 2.05188 4.95842 2.83317V4.24984H2.83341C2.05212 4.24984 1.41675 4.88521 1.41675 5.6665V13.4582C1.41675 14.2395 2.05212 14.8748 2.83341 14.8748H14.1667C14.948 14.8748 15.5834 14.2395 15.5834 13.4582V5.6665C15.5834 4.88521 14.948 4.24984 14.1667 4.24984ZM10.6251 2.83317V4.24984H6.37508V2.83317H10.6251ZM5.66675 5.6665H14.1667V7.7915H2.83341V5.6665H5.66675ZM2.83341 13.4582V9.20817H7.08342V10.6248H9.91675V9.20817H14.1667L14.1675 13.4582H2.83341Z"
      fill="#BABABA"
    />
  </svg>,
  "JobIcon"
);
